export default "__VITE_ASSET__B7WFARJD__"